export const constants = {
    MESSAGE_CREATE_ENDPOINT_SUCCESSFULLY: 'The endpoint is successfully created',
    MULTIPLICITY_DSP_QPS: 96,
};

export default constants;
